export default __webpack_public_path__ + "static/media/misc-books1-1920w.78f802ad.webp";